import tavOffice from "../img/homepage-work-images/Tav Office.jpg";
import acasa from "../img/homepage-work-images/Acasa.jpg";
import khanaBalaVilla from "../img/homepage-work-images/khane bala villa.jpg";
import sketch from "../img/Sketch about us/pen3.jpg";
import sketch2 from "../img/Sketch about us/PEN02.jpg";
import logo from "../img/logo/light-logo.png";
import logoBlack from "../img/logo/dark-logo.png";
import archive1 from "../img/archive/01.jpg";
import archive2 from "../img/archive/02.jpg";
import archive3 from "../img/archive/03.jpg";
import archive4 from "../img/archive/04.jpg";
import archive5 from "../img/archive/05.jpg";
import archive6 from "../img/archive/06.jpg";
import archive7 from "../img/archive/08.jpg";
import archive8 from "../img/archive/09.jpg";
import archive9 from "../img/archive/10.jpg";
import archive10 from "../img/archive/11.jpg";
import archive11 from "../img/archive/12.jpg";
import archive12 from "../img/archive/13.jpg";
import archive13 from "../img/archive/14.jpg";
import archive14 from "../img/archive/15.jpg";
import archive15 from "../img/archive/14(1).jpg";
import archive16 from "../img/archive/16.jpg";
import archive17 from "../img/archive/17.jpg";
import archive18 from "../img/archive/18.jpg";
import archive19 from "../img/archive/19.jpg";
import archive20 from "../img/archive/19(1).jpg";
import archive21 from "../img/archive/20.jpg";
import archive22 from "../img/archive/21.jpg";
import archive23 from "../img/archive/22.jpg";
import archive24 from "../img/archive/23.jpg";
import archive25 from "../img/archive/24.jpg";
import archive26 from "../img/archive/25.jpg";
import archive28 from "../img/archive/26.jpg";
import archive29 from "../img/archive/27.jpg";
import archive30 from "../img/archive/128.jpg";
import archive31 from "../img/archive/29.jpg";
import archive32 from "../img/archive/30.jpg";
import archive33 from "../img/archive/31.jpg";
import archive34 from "../img/archive/32.jpg";
import archive35 from "../img/archive/33(1).jpg";
import archive36 from "../img/archive/33(2).jpg";
import archive37 from "../img/archive/33(3).jpg";
import archive38 from "../img/archive/33(4).jpg";
import archive39 from "../img/archive/34.jpg";
import archive40 from "../img/archive/35.jpg";
import archive41 from "../img/archive/36.jpg";
import archive42 from "../img/archive/37.jpg";
import archive43 from "../img/archive/38.jpg";
import archive44 from "../img/archive/39.jpg";
import archive45 from "../img/archive/40.jpg";
import archive46 from "../img/archive/41.jpg";
import archive47 from "../img/archive/42.jpg";
import archive48 from "../img/archive/43.jpg";
import archive49 from "../img/archive/45.jpg";
import archive50 from "../img/archive/46.jpg";
import archive51 from "../img/archive/47.jpg";
import archive52 from "../img/archive/48.jpg";
import archive53 from "../img/archive/49.jpg";
import archive54 from "../img/archive/49(1).jpg";
import archive55 from "../img/archive/50.jpg";
import archive56 from "../img/archive/51.jpg";
import archive57 from "../img/archive/52.jpg";
import archive58 from "../img/archive/53.jpg";
import archive61 from "../img/archive/54(3).jpg";
import archive62 from "../img/archive/54(4).jpg";
import archive63 from "../img/archive/54(5).jpg";
import archive64 from "../img/archive/54(6).jpg";
import archive65 from "../img/archive/54.jpg";
import archive66 from "../img/archive/55.jpg";
import archive67 from "../img/archive/56.jpg";
import archive68 from "../img/archive/57.jpg";
import archive69 from "../img/archive/58.jpg";
import archive70 from "../img/archive/59.jpg";
import archive71 from "../img/archive/60.jpg";
import archive72 from "../img/archive/61.jpg";
import archive73 from "../img/archive/62.jpg";
import archive74 from "../img/archive/63.jpg";
import archive75 from "../img/archive/64.jpg";
import archive76 from "../img/archive/65.jpg";
import archive77 from "../img/archive/66.jpg";
import archive78 from "../img/archive/67.jpg";
import archive79 from "../img/archive/68.jpg";
import archive80 from "../img/archive/69.jpg";
import archive81 from "../img/archive/70.jpg";
import archive82 from "../img/archive/72.jpg";
import archive83 from "../img/archive/73.jpg";
import archive84 from "../img/archive/74.jpg";
import archive85 from "../img/archive/75.jpg";
import archive86 from "../img/archive/76.jpg";
import archive87 from "../img/archive/76(1).jpg";
import archive88 from "../img/archive/77.jpg";
import archive89 from "../img/archive/77(1).jpg";
import archive90 from "../img/archive/78.jpg";
import archive91 from "../img/archive/79.jpg";
import archive92 from "../img/archive/80.jpg";
import archive93 from "../img/archive/81.jpg";
import archive94 from "../img/archive/82.jpg";
import archive95 from "../img/archive/83.jpg";
import archive96 from "../img/archive/84.jpg";
import archive97 from "../img/archive/85.jpg";
import archive98 from "../img/archive/86.jpg";
import archive99 from "../img/archive/87.jpg";
import archive100 from "../img/archive/88.jpg";
import archive101 from "../img/archive/89.jpg";
import archive102 from "../img/archive/88(1).jpg";
import archive103 from "../img/archive/90.jpg";
import archive104 from "../img/archive/91.jpg";
import archive105 from "../img/archive/92.jpg";
import archive106 from "../img/archive/93.jpg";
import archive107 from "../img/archive/94.jpg";
import archive108 from "../img/archive/95.jpg";
import archive109 from "../img/archive/96.jpg";
import archive110 from "../img/archive/97.jpg";
import archive111 from "../img/archive/98.jpg";
import archive112 from "../img/archive/99.jpg";
import archive113 from "../img/archive/100.jpg";
import archive114 from "../img/archive/101.jpg";
import archive115 from "../img/archive/102.jpg";
import archive116 from "../img/archive/103.jpg";
import archive117 from "../img/archive/104.jpg";
import archive118 from "../img/archive/105.jpg";
import archive119 from "../img/archive/106.jpg";
import archive120 from "../img/archive/107.jpg";
import archive121 from "../img/archive/108.jpg";
import archive122 from "../img/archive/109.jpg";
import archive123 from "../img/archive/110.jpg";
import archive124 from "../img/archive/111.jpg";
import archive125 from "../img/archive/112.jpg";
import archive126 from "../img/archive/112(1).jpg";
import archive127 from "../img/archive/113.jpg";
import archive128 from "../img/archive/114.jpg";
import archive129 from "../img/archive/115.jpg";
import archive130 from "../img/archive/116.jpg";
import archive131 from "../img/archive/117.jpg";
import archive132 from "../img/archive/118.jpg";
import archive133 from "../img/archive/119.jpg";
import archive134 from "../img/archive/120.jpg";
import archive135 from "../img/archive/121.jpg";
import archive136 from "../img/archive/122.jpg";
import archive137 from "../img/archive/123.jpg";
import archive138 from "../img/archive/124.jpg";
import archive139 from "../img/archive/125.jpg";
import archive140 from "../img/archive/126.jpg";
import archive141 from "../img/archive/127.jpg";
import archive142 from "../img/archive/128.jpg";
import archive143 from "../img/archive/129.jpg";
import archive144 from "../img/archive/130.jpg";
import archive145 from "../img/archive/131.jpg";
import archive146 from "../img/archive/132.jpg";
import archive147 from "../img/archive/131(1).jpg";
import archive148 from "../img/archive/132(1).jpg";
import archive149 from "../img/archive/132(2).jpg";
import archive150 from "../img/archive/132(3).jpg";
import archive151 from "../img/archive/133.jpg";
import archive152 from "../img/archive/134.jpg";
import archive153 from "../img/archive/135.jpg";
import leeds from "../img/solar-system-img/image010.jpg";
import leedsLogo from "../img/solar-system-img/image010.jpg";
import reddingSchool from "../img/solar-system-img/image012.jpg";
import panel1 from "../img/solar-system-img/image014.jpg";
import panel2 from "../img/solar-system-img/image016.jpg";
import systemWork1 from "../img/solar-system-img/image020.png";
import systemWork2 from "../img/solar-system-img/image022.jpg";
import systemWork3 from "../img/solar-system-img/image023.png";
import systemProcess1 from "../img/solar-system-img/image024.png";
import systemProcess2 from "../img/solar-system-img/image026.jpg";
import monocrystalline from "../img/solar-system-img/image031.jpg";
import monocrystallineData1 from "../img/solar-system-img/image040.jpg";
import monocrystallineData2 from "../img/solar-system-img/image041.png";
import polycrystalline1 from "../img/solar-system-img/image044.jpg";
import polycrystalline2 from "../img/solar-system-img/image046.png";
import solarFilm1 from "../img/solar-system-img/image048.jpg";
import solarFilm2 from "../img/solar-system-img/image049.png";
import solarType from "../img/solar-system-img/image053.jpg";
import solarFlexible1 from "../img/solar-system-img/image055.jpg";
import solarFlexible2 from "../img/solar-system-img/image056.jpg";
import solarFlexible3 from "../img/solar-system-img/image059.jpg";
import solarFlexible4 from "../img/solar-system-img/image062.jpg";
import solarFlexible5 from "../img/solar-system-img/image063.jpg";
import energyFlower from "../img/solar-system-img/image065.jpg";
import caseStudy1 from "../img/solar-system-img/image067.jpg";
import caseStudy2 from "../img/solar-system-img/image069.jpg";
import caseStudy3 from "../img/solar-system-img/image073.jpg";
import caseStudy4 from "../img/solar-system-img/image074.jpg";
import ringdalskogenHouse from "../img/solar-system-img/image078.jpg";
import solarBuilding from "../img/solar-system-img/image081.jpg";
import faLanguage from "../img/iran.png";
import enLanguage from "../img/united-kingdom.png";


export const languageImages = {
  faLanguage,
  enLanguage,
};

export const solarSystem = {
  leeds,
  // leedsCategory,
  leedsLogo,
  monocrystalline,
  solarType,
  energyFlower,
  ringdalskogenHouse,
  solarBuilding,
};
export const solarSystemWork = [systemWork1, systemWork2, systemWork3];
export const solarArt = [reddingSchool, panel1, panel2];
export const solarProcess = [systemProcess1, systemProcess2];
export const monocrystallineData = [monocrystallineData1, monocrystallineData2];
export const polycrystallineData = [polycrystalline1, polycrystalline2];
export const solarFilmData = [solarFilm1, solarFilm2];
export const solarFlexibleData = [
  solarFlexible1,
  solarFlexible2,
  solarFlexible3,
  solarFlexible4,
  solarFlexible5,
];
export const solarCaseStudyData = [
  caseStudy1,
  caseStudy2,
  caseStudy3,
  caseStudy4,
];

export default {
  tavOffice,
  acasa,
  khanaBalaVilla,
  sketch,
  logo,
  logoBlack,
  sketch2,
};

export const archiveImages = [
  archive3,
  archive4,
  archive1,
  archive10,
  archive2,
  archive11,
  archive12,
  archive5,
  archive6,
  archive7,
  archive8,
  archive9,
  archive13,
  archive14,
  archive15,
  archive16,
  archive17,
  archive18,
  archive19,
  archive20,
  archive21,
  archive22,
  archive23,
  archive24,
  archive25,
  archive26,
  archive28,
  archive29,
  archive30,
  archive31,
  archive32,
  archive33,
  archive34,
  archive35,
  archive36,
  archive37,
  archive38,
  archive39,
  archive40,
  archive41,
  archive42,
  archive43,
  archive44,
  archive45,
  archive46,
  archive47,
  archive48,
  archive49,
  archive50,
  archive51,
  archive52,
  archive53,
  archive54,
  archive55,
  archive56,
  archive57,
  archive58,
  // archive59,
  // archive60,
  archive61,
  archive62,
  archive63,
  archive64,
  archive65,
  archive66,
  archive67,
  archive68,
  archive69,
  archive70,
  archive71,
  archive72,
  archive73,
  archive74,
  archive75,
  archive76,
  archive77,
  archive78,
  archive79,
  archive80,
  archive81,
  archive82,
  archive83,
  archive84,
  archive85,
  archive86,
  archive87,
  archive88,
  archive89,
  archive90,
  archive91,
  archive92,
  archive93,
  archive94,
  archive95,
  archive96,
  archive97,
  archive98,
  archive99,
  archive100,
  archive101,
  archive102,
  archive103,
  archive104,
  archive105,
  archive106,
  archive107,
  archive108,
  archive109,
  archive110,
  archive111,
  archive112,
  archive113,
  archive114,
  archive115,
  archive116,
  archive117,
  archive118,
  archive119,
  archive120,
  archive121,
  archive122,
  archive123,
  archive124,
  archive125,
  archive126,
  archive127,
  archive128,
  archive129,
  archive130,
  archive131,
  archive132,
  archive133,
  archive134,
  archive135,
  archive136,
  archive137,
  archive138,
  archive139,
  archive140,
  archive141,
  archive142,
  archive143,
  archive144,
  archive145,
  archive146,
  archive147,
  archive148,
  archive149,
  archive150,
  archive151,
  archive152,
  archive153,
];

